import { defineModel } from "../define-model";
import type { SocialPlatform } from "./social-account";

export type Sentiment = "positive" | "neutral" | "negative" | "mixed";

export type SocialComment = {
	id: string;
	workspaceId: string;
	projectId: string;
	socialAccountId: string;
	postTargetId: string | null;
	platform: SocialPlatform;
	externalCommentId: string;
	externalPostId: string;
	parentExternalId: string | null;
	authorHandle: string | null;
	authorName: string | null;
	authorAvatarUrl: string | null;
	text: string;
	likeCount: number;
	replyCount: number;
	sentiment: Sentiment | null;
	status: "new" | "read" | "replied" | "hidden";
	/** Written by the connected account itself. */
	isOwner: boolean;
	postedAt: string | null;
	replyText: string | null;
	repliedAt: string | null;
	/** Removed on the platform. */
	deletedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		socialComment: SocialComment;
	}
}

export const model = defineModel({
	name: "socialComment",
	load: "lazy",
	indexes: ["projectId", "postTargetId"],
	sort: (a, b) => (b.postedAt ?? b.createdAt).localeCompare(a.postedAt ?? a.createdAt),
});
